import React, { useState } from 'react'
import { useSelector, useDispatch } from "react-redux";
import _ from "lodash"
import { Button, Grid, Typography, Box, Checkbox, Dialog, DialogTitle, DialogContent } from '@mui/material'
import { motion, AnimatePresence } from "framer-motion/dist/framer-motion"
import { contextUpsert, selectContextEntities } from '../../../reducers/global_contexts';
import ParticipantCreate from './ParticipantCreate';
import { adminparticipantClear } from "../../../reducers/admincenter_participants"
import { Refresh } from '@mui/icons-material';
/**
 * 
 * {"ParticipantTab": {
                    "TabName": "Participants",
                    "ParticipantHome": {
                        "CreatePartLink": {
                            "LinkText": "Create Participant"
                        },
                        "PartMngViewButton": {
                            "ButtonText": "Export"
                        },
                        "PartMngClearAllButton": {
                            "ButtonText": "Clear Filters"
                        },
                        "PartMngSearchBox": {
                            "Prompt": "search by name, username, group name, etc"
                        },
                        "PartMngArchivedPartsCheckBox": {
                            "BoxText": "Include archived participants"
                        },
                        "NoResultsMessage": {
                            "MessageText": "No matching records found; please try a different search."
                        },
                        "ViewAllParticipant": {
                            "ButtonText": "View All Participants"
                        },
                        "SelectAllCheckbox": {
                            "BoxText": "Select All"
                        },
                        "SearchResultsCount": {
                            "CountResult": "0"
                        },
                        "SearchFilter": {
                            "FilterCategory": "FirstName"
                        },
                        "BackToDashboardAppNav": {
                            "NavText": "Start Over"
                        }
                    },
                    "ParticipantSearchResults": {
                        "PartMngSearchResultsHeader": {
                            "FirstNameHeader": "First Name",
                            "LastNameHeader": "Last Name",
                            "UserNameHeader": "Username",
                            "GroupNameHeader": "Group Name",
                            "StatusHeader": "Status",
                            "DobHeader": "DOB",
                            "LastHraHeader": "Last HRA Started",
                            "LastLoginHeader": "Last Login"
                        }
                    },
                    "ParticipantMerge": {
                        "CancelButton": "Cancel",
                        "CloseButton": "Close",
                        "ContinueButton": "Continue",
                        "SearchMessage": "Please select the participant you would like to merge into.",
                        "Title": "Merge Participant",
                        "DestinationAccountLabel": "Destination Account",
                        "MergeButton": "Merge",
                        "SourceAccountLabel": "Source Account",
                        "ConfirmMessage": "You're about to merge the SOURCE account into the DESTINATION account. All assessments will be moved to the DESTINATION account and the SOURCE account will be permanently deleted. Click MERGE to continue.",
                        "SuccessMessage": "These two participants have successfully been merged."
                    },
                    "ParticipantArchive": {
                        "CloseButton": "Close",
                        "ConfirmButton": "Confirm",
                        "Message": "Archiving a participant will remove them from the default search results.",
                        "Message2": "Archiving participants will still show up in group reports unless they are excluded through advanced report options.",
                        "Title": "ARCHIVE PARTICIPANT"
                    },
                    "GroupSelect": {
                        "Label": "Select group",
                        "CancelButton": "Cancel",
                        "SelectButton": "Select",
                        "Title": "CHANGE PARTICIPANT'S LANGUAGE",
                        "Message": "In order to complete this move, the participant's language will be changed from [LANGUAGE] to",
                        "ContinueButton": "Continue",
                        "CloseButton": "Close"
                    },
                    "ModalSendInvite": {
                        "Title": "Send Invite",
                        "EmailToLabel": "To:",
                        "EmailTo": "<<EmailTo>>",
                        "EmailSubjectLabel": "Subject:",
                        "EmailSubject": "Login Instructions for Your Health Risk Assessment",
                        "EmailBodyLabel": "Message:",
                        "EmailBody": "You are invited to take an online health risk assessment (HRA).  Here's what to do next:    1. Click the link below.   2. Set your password.  3. On the login page, enter your username and your password.    The HRA will only take about 10-15 minutes to fill out. Click the login link below to get started!",
                        "AppendedTextLabel": "Appended Text (Read Only)",
                        "AppendedText": "<br/><a href=\"[CUSTOMER-SITE-DOMAIN-LEAVE-THIS-ALONE!]/WsWebAppWellSuite/index.html[QUERYSTRING-PARAMS-LEAVE-THIS-ALONE!]\" title=\"\" target=\"_blank\">Login</a>",
                        "SendLabel": "Send",
                        "CancelLabel": "Cancel",
                        "CloseLabel": "Close",
                        "SaveAsTemplateLabel": "Save as group template "
                    }
                }}  
 *  
 */
const ParticipantControl = (props) => {
    const dispatch = useDispatch()
    const ParticipantTab = props.ParticipantTab
    const ParticipantHome = ParticipantTab.ParticipantHome

    const Contexts = useSelector(state => selectContextEntities(state))

    const { showArchivedParticipants } = Contexts

    const [isCreateOpen, setIsCreateOpen] = useState(false)

    const handleClose = () => {
        setIsCreateOpen(false)
        dispatch(adminparticipantClear())
    }

    const handleOpen = () => {
        setIsCreateOpen(true)
    }
    const handleInactiveParticipants = (nv) => {
        dispatch(contextUpsert({ Key: "showArchivedParticipants", Value: nv }))
    }
    return (
        <Grid container direction="row" alignItems="center" justifyContent="center" spacing={2}>
            <Grid item xs={12}>
                <Box sx={{ alignItems: "center", display: "flex", flexDirection: "row", justifyContent: "flex-start" }}  >
                    <Button variant="outlined" color="success" onClick={() => { handleOpen() }}>
                        {ParticipantHome.CreatePartLink.LinkText}
                    </Button>
                </Box>
            </Grid>

            <Grid item xs={6}>
                <Box sx={{ alignItems: "center", display: "flex", flexDirection: "row", justifyContent: "flex-start" }}  >
                    <Checkbox checked={showArchivedParticipants} onChange={(e) => { handleInactiveParticipants(e.target.checked) }} />
                    <Typography variant='caption'>{ParticipantHome.PartMngArchivedPartsCheckBox.BoxText}</Typography>
                </Box>
            </Grid>

            <Grid item xs={6}>
                <Box sx={{ alignItems: "center", display: "flex", flexDirection: "row", justifyContent: "flex-start" }}  >
                    <Refresh onClick={() => {handleClose() }} />
                    <Typography variant='caption'>Refresh participant list</Typography>
                </Box>
            </Grid>

            <Dialog
                maxWidth="lg"
                fullWidth
                open={isCreateOpen}
                close={() => { handleClose() }}
            >
                <DialogTitle>
                    <Typography variant="h4" align="center">Create Participant</Typography>
                </DialogTitle>
                <DialogContent>
                    <Box my={2}>
                        <ParticipantCreate onCloseButton={() => { handleClose() }} />
                    </Box>
                </DialogContent>
            </Dialog>
        </Grid>
    )

}
export default ParticipantControl